import React from "react";

const ErrorMessage = ({ message }) =>
  message && <div className="text-sm text-red-500">{message}</div>;

export default ErrorMessage;
